module.exports = __webpack_public_path__ + "static/media/cardSix.7e2378aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowSix/cardSix.jpg
// module id = 88
// module chunks = 0